var _excluded = ["icon", "label", "isDisabled", "isLoading", "variant", "isFullWidth", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon } from '../../../foundations/Icon';
import { Loader } from '../../../foundations/Loader';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Button = forwardRef((props, ref) => {
  var {
    icon,
    label,
    isDisabled,
    isLoading,
    variant = 'primary',
    isFullWidth,
    children
  } = props,
      otherProps = _objectWithoutProperties(props, _excluded);

  var styles = useMultiStyleConfig('Button', props);
  var loaderColorMap = {
    primary: 'neutral.white',
    secondary: undefined,
    'secondary-inverted': 'neutral.white',
    tertiary: 'neutral.black',
    success: 'neutral.white',
    critical: 'neutral.white',
    'critical-secondary': 'critical.dark'
  };
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    "data-component": "Button",
    as: "button",
    type: "button",
    __css: styles['container'],
    "aria-label": label
  }, otherProps), {}, {
    tabIndex: isDisabled ? -1 : 0 // ts-ignore is used due to type issues with `Box`.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    disabled: isDisabled,
    "data-loading": isLoading || null,
    ref: ref,
    children: [/*#__PURE__*/_jsxs(Box, {
      as: "span",
      __css: styles['label'],
      children: [icon && /*#__PURE__*/_jsx(Box, {
        as: "span",
        __css: styles['icon'],
        children: /*#__PURE__*/_jsx(Icon, {
          size: "small",
          type: icon,
          color: "inherit"
        })
      }), label]
    }), isLoading && /*#__PURE__*/_jsx(Box, {
      as: "span",
      __css: styles['loader'],
      children: /*#__PURE__*/_jsx(Loader, {
        color: loaderColorMap[variant]
      })
    })]
  }));
});
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map